import React, { useEffect, useRef, useState } from "react"
import gsap from "gsap"

interface AnimatedNavBarProps {
  children: React.ReactNode
  className?: string
  trigger?: any
}

/**
 * AnimatedSubMenu
 * @param children - The sub menu links
 * @param className - The class name of the sub menu needed for styling the children of this component.
 * @param trigger - Used to reset the animation of sub menu. Must be a state that rerender the component.
 */
export const AnimatedNavBar: React.FC<AnimatedNavBarProps> = ({
  children,
  className,
  trigger,
}) => {
  const parentRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (parentRef.current) {
      gsap.fromTo(
        parentRef.current.children,
        { opacity: 0, x: -30 },
        {
          opacity: 1,
          x: 0,
          duration: 0.4,
          delay: 0.8,
          stagger: 0.1,
          ease: "power1.in",
          onComplete: () => {},
        },
      )

      document.documentElement.style.setProperty(
        "--pseudo-element-opacity",
        "0",
      )
      document.documentElement.style.setProperty(
        "--pseudo-element-height",
        "0%",
      )

      gsap.to(document.documentElement, {
        "--pseudo-element-opacity": 1,
        "--pseudo-element-height": "90%",
        duration: 0.8,
        delay: 0.6,
        ease: "power1.in",
        onComplete: () => {},
      })
    }
  }, [trigger])

  return (
    <div className={className} ref={parentRef} key={trigger}>
      {React.Children.toArray(children)}
    </div>
  )
}
